/* eslint-disable react/prop-types */
import React from 'react';
import { getColorProfile } from './colorProfiles';
import { IconLeft, IconRight } from './Icon';

const withButtonProps = (Component, opts = {}) =>
  React.memo(React.forwardRef((props, ref) => {
    const colorProfile = getColorProfile(props);

    const {
      size = 'large',
      colorSet = 'teal',
      invert = false,
      icon,
      iconLeft,
      bkgColor = colorProfile.bkg,
      textColor = colorProfile.text,
      shadowColor = colorProfile.shadow,
      highlightColor = colorProfile.highlight,
      children,
      ...propsToPass
    } = props;

    const iconSize = opts?.iconSizes?.[size] ?? size;

    return (
      <Component
        size={size}
        colorSet={colorSet}
        invert={invert}
        bkgColor={bkgColor}
        shadowColor={shadowColor}
        highlightColor={highlightColor}
        textColor={textColor}
        {...propsToPass}
        ref={ref}
      >
        {iconLeft && (
          <IconLeft name={iconLeft} size={iconSize} fill={textColor} />
        )}
        {children}
        {icon && <IconRight name={icon} size={iconSize} fill={textColor} />}
      </Component>
    );
  }));

export default withButtonProps;
